<template>
  <div class="wrapperPage pt-8">
    <div class="container pb-12">
      <div class="logo w-full p-1 flex justify-center sm:justify-start">
        <img class="" :src="logo" width="200" />
      </div>
      <div class="logo w-full p-1 flex justify-center sm:justify-start">
        <img width="200" />
      </div>
      <div>
        <div class="dadosBP w-full p-1 text-sm">
          <h3 class="flex justify-center mb-4">
            {{ this.termosContrato[0].tipoContrato }}
          </h3>
        </div>
        <vx-card class="mt-3">
          <div
            style="text-align: justify"
            class="textoContrato mb-8"
            v-html="modeloContrato"
          ></div>
          <div class="flex flex-col sm:flex-row sm:justify-around mt-12">
            <div class="items-left">
              <img
                v-if="
                  this.dadosProposta.idEmpresa == 118 ||
                  this.dadosProposta.idEmpresa == 119 ||
                  this.dadosProposta.idEmpresa == 120 ||
                  this.dadosProposta.idEmpresa == 123
                "
                class="imagem"
                src="https://bboneapp.s3.amazonaws.com/assinatura-contrato-bp1.png"
                width="200"
              />
              <img
                v-if="this.dadosProposta.idEmpresa == 121"
                class="imagem"
                src="https://bboneapp.s3.amazonaws.com/assinatura-viavante.png"
                height="100"
              />
              <p><b>____________________________________</b></p>
              <p>
                <b>
                  {{
                    dadosProposta.idEmpresa == 120
                      ? 'Bem Protege'
                      : dadosProposta.dadosAssociacao.nome
                  }}</b
                >
              </p>
              <P v-if="this.dadosProposta.idEmpresa == 117"
                ><b>10.476.457/0001-20</b></P
              >
              <P
                v-if="
                  this.dadosProposta.idEmpresa == 118 ||
                  this.dadosProposta.idEmpresa == 119 ||
                  this.dadosProposta.idEmpresa == 120 ||
                  this.dadosProposta.idEmpresa == 123
                "
                ><b>13.762.231/0001-84</b></P
              >
              <P v-else
                ><b>{{ dadosProposta.dadosAssociacao.cnpj }}</b></P
              >
            </div>
            <div>
              <img
                v-if="dadosProposta.assinatura"
                class="imagem"
                :src="dadosProposta.assinatura"
                height="100"
                style="margin-left: 15px"
              />
              <div v-else style="height: 100px; margin-left: 15px"></div>
              <p><b>____________________________________</b></p>
              <p>
                <b>{{ dadosProposta.dadosCliente.associado }}</b>
              </p>
              <p>
                <b>{{ dadosProposta.dadosCliente.cpf }}</b>
              </p>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import service from '../../services';
import jwt from 'jsonwebtoken';
import { decryptData } from '../../services/decryptData';

export default {
  data() {
    return {
      idModelo: null,
      idEmpresa: null,
      modeloContrato: null,
      tipoContrato: null,
      termosContrato: [],
      logo: null,
      dadosProposta: null,
      idProposta: null,
      chave: null,
    };
  },
  methods: {
    async buscaTermos() {
      try {
        this.$vs.loading();

        const decoded = jwt.decode(localStorage.getItem('user-token'));
        this.idEmpresa = decoded.id_empresa;

        const { data } = await service.post(
          'ModelosContratos',
          'BuscaContrato',
          { idEmpresa: this.idEmpresa },
        );

        this.idModelo = this.$route.params.idModelo;
        this.termosContrato = data.filter(
          (item) => item.idModelo === parseInt(this.idModelo),
        );

        if (!this.termosContrato) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'erro ao buscar Termo do contrato',
            color: 'danger',
          });
          this.$vs.loading.close();
        }
        this.modeloContrato = this.termosContrato[0].modeloContrato;
        this.tipoContrato = this.termosContrato[0].tipoContrato;

        this.$vs.loading.close();
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error.message || error,
          color: 'danger',
        });
        this.$vs.loading.close();
      }
    },
    async buscaDadosEmpresa() {
      try {
        this.$vs.loading();
        const res = await service.getAll(
          'g',
          {},
          'empresas/list/idEmpresa/' + this.idEmpresa,
        );

        const [Empresa] = decryptData(res.data);
        this.logo = Empresa.logo;

        this.$vs.loading.close();
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error,
          color: 'danger',
        });
        this.$vs.loading.close();
      }
    },
    async buscaDados() {
      this.$vs.loading();

      this.chave = this.$route.params.chave;
      this.idProposta = this.$route.params.idProposta;

      const objSend = {
        chave: this.chave,
        idProposta: this.idProposta,
      };

      try {
        const res = await service.post('CotacaoAberta', 'buscaDados', objSend);

        this.dadosProposta = res.data[0];
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error.message || 'Erro ao buscar dados',
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  mounted() {
    this.buscaTermos();
    this.buscaDadosEmpresa();
    this.buscaDados();
  },
};
</script>

<style>
@import url('https://fonts.cdnfonts.com/css/gotham');

.wrapperPage {
  font-family: 'regular', 'Gotham', sans-serif;
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
}

table {
  width: 100%;
  gap: 20px;
}

tr:nth-child(odd) {
  background-color: #edf4fb;
}

.title {
  background-color: #043562 !important;
  color: white;
}

.listItemsProtecoes {
  color: rgb(59, 59, 59);
  font-size: 0.9rem;
  font-weight: 600;
}

.A3 .sheet {
  width: 297mm;
  height: 419mm;
}
.A3.landscape .sheet {
  width: 420mm;
  height: 296mm;
}
.A4 .sheet {
  width: 210mm;
  height: 296mm;
}
.A4.landscape .sheet {
  width: 297mm;
  height: 209mm;
}
.A5 .sheet {
  width: 148mm;
  height: 209mm;
}
.A5.landscape .sheet {
  width: 210mm;
  height: 147mm;
}

/** Padding area **/
.sheet.padding-10mm {
  padding: 10mm;
}
.sheet.padding-15mm {
  padding: 15mm;
}
.sheet.padding-20mm {
  padding: 20mm;
}
.sheet.padding-25mm {
  padding: 25mm;
}
/** For screen preview **/
@media screen {
  body {
    background: #e0e0e0;
    display: flex;
    justify-content: center;
  }
  .sheet,
  .quebraPagina {
    background: white;
    box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3);
    margin-top: 1em;
    margin-bottom: 1em;
  }
}

/** Fix for Chrome issue #273306 **/
@media print {
  .A3.landscape {
    width: 420mm;
  }
  .A3,
  .A4.landscape {
    width: 297mm;
  }
  .A4,
  .A5.landscape {
    width: 210mm;
  }
  .A5 {
    width: 148mm;
  }
}
@media screen {
  .printer {
    display: none;
  }
}
@media print {
  .non-printer {
    display: none;
  }
  .vue-back-to-top {
    display: none !important;
  }
  .pdf {
    width: auto;
    height: 200mm;
  }
  .folha {
    height: 297mm;
    padding: 0 0 0 0;
    page-break-after: always;
  }
  .btn-print {
    display: none;
  }
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .router-header,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}
</style>
